import postWithToken from './base/post-with-token'

const toggleUserReceiveEmailAlert = ({ email, is_alert }) =>
  postWithToken('/list-receive-email-alert/toggle-user')({
    email,
    is_alert,
  })

export default toggleUserReceiveEmailAlert
